import { render, staticRenderFns } from "./AddingNewDecision.vue?vue&type=template&id=640986ba&scoped=true"
import script from "./AddingNewDecision.vue?vue&type=script&lang=js"
export * from "./AddingNewDecision.vue?vue&type=script&lang=js"
import style0 from "./AddingNewDecision.vue?vue&type=style&index=0&id=640986ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640986ba",
  null
  
)

export default component.exports